import { Route, Switch } from 'react-router';
import { DatasetImport } from './dataset-import/DatasetImport';
import { DatasetList } from './dataset-list';
import { OperationStatusTableWrapper } from './dataset-operations';
import { DatasetSettingsWrapper } from './dataset-settings/DatasetSettings';
import { DatasetTableWrapper } from './dataset-table';
import {
  datasetCreateRoute,
  datasetLogsRoute,
  datasetSettingsRoute,
  datasetsPath,
  datasetTableRoute,
} from './routes';

export const DatasetsRoutes = () => {
  return (
    <Switch>
      <Route path={datasetsPath()} exact component={DatasetList} />
      <Route path={datasetCreateRoute()} exact component={DatasetImport} />
      <Route path={datasetTableRoute()} exact component={DatasetTableWrapper} />
      <Route
        path={datasetSettingsRoute()}
        exact
        component={DatasetSettingsWrapper}
      />
      <Route
        path={datasetLogsRoute()}
        exact
        component={OperationStatusTableWrapper}
      />
    </Switch>
  );
};
